import { IEndClientMast } from "../../models/EndClientMast";

export const EmptyEndClient:IEndClientMast ={
    end_Client_Id :0,
    end_Client_Name:"",
    industry_Id :0,
    linkendin :"",
    industry_Name:""
}